import { CustomDatasetFilterType, DatasetFiltersType } from "data/models";
import { Form, Formik } from "formik";

import { useIdentity } from "contexts/identity-context";
import { useEffect, useState } from "react";
import { resolveIdentityId } from "utils/identity";
import { transformDateFormat } from "../utils";

export default function FilterComponent({
  initialQueryFilterState,
  queryFilterState,
  setQueryFilterState,
  renderFilter,
  definitions,
  localStorageKey,
  children,
}: any) {
  const [time, setTime] = useState({ startTime: 0, endTime: 0 });

  const [identityState] = useIdentity();

  const identityId = resolveIdentityId(identityState);

  const [presetRange, setPresetRange] = useState(
    queryFilterState?.release
      ? transformDateFormat(queryFilterState.release)
      : "",
  );

  useEffect(() => {
    setPresetRange(
      queryFilterState?.release
        ? transformDateFormat(queryFilterState.release)
        : "",
    );
  }, [queryFilterState]);

  type CombinedFiltersType = DatasetFiltersType | CustomDatasetFilterType;

  return (
    <Formik<CombinedFiltersType>
      initialValues={queryFilterState}
      onSubmit={(values) => {
        setQueryFilterState(values);
        localStorage.setItem(localStorageKey, JSON.stringify(values));
      }}
      enableReinitialize={true}
    >
      {({
        values,
        handleChange,
        handleSubmit,
        handleBlur,
        setFieldValue,
        resetForm,
        submitForm,
        errors,
        touched,
      }) => {
        const RenderFilter = renderFilter;
        return (
          <Form className="w-full flex flex-col">
            <RenderFilter
              values={values}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              definitions={definitions}
              time={time}
              setTime={setTime}
              setFieldValue={setFieldValue}
              setQueryFilterState={setQueryFilterState}
              resetForm={resetForm}
              presetRange={presetRange}
              setPresetRange={setPresetRange}
              initialQueryFilterState={initialQueryFilterState}
              queryFilterState={queryFilterState}
              localStorageKey={localStorageKey}
            >
              {children}
            </RenderFilter>
          </Form>
        );
      }}
    </Formik>
  );
}
